import React, { Component } from 'react';
import DialogBox from '../../container/MUI/DialogBox';
import InputText from './Form';
import Button from '@mui/material/Button';
import Warning from '@mui/icons-material/Warning';
import { TextField, Box } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';


class DeleteDialog extends Component {
    state = {
        MDP: "",
        errors:{
            MDP:""
        }
    }
    handleChange = (e) => {
        this.setState({
            MDP: e.target.value
        })
    }
    handleSubmit = () => {
        // validateBackend: opt-in mode where the password is sent to the backend
        // for validation (password + admin role, COMPTA-220) instead of being
        // compared locally against the hardcoded value.
        if (this.props.validateBackend) {
            this.props.handleSubmit(this.state.MDP)
            return
        }
        // if( this.state.MDP === ""){
        if( this.state.MDP === "UnMDPSuperDifficile"){
            this.props.handleSubmit()
        } else {
            this.setState({
                errors:{
                    MDP: "Mot de Passe Incorrect"
                }
            })
        }
    }
    render() {
        return (
            <DialogBox 
                disableBackdropClick
                open={this.props.open}
                close={this.props.close}
                title={`Supprimer ${this.props.title}`}
            >
                <Box>
                    <Box p={1}>
                        {this.props.children || this.props.text}
                    </Box>
                    <Alert severity="error">
                        <AlertTitle >Attention</AlertTitle>
                        Cette action sera irréversible
                    </Alert>
                    <Box p={1}>
                        <InputText
                            type="password"
                            name="MDP" 
                            value={this.state.MDP} 
                            label="Mot de Passe" 
                            placeholder="Mot De Passe" 
                            required
                            error={this.state.errors.MDP || this.props.externalError}
                            onChange={this.handleChange}
                        />
                    </Box>
                </Box>

                <Box>
                    <Button variant="contained" onClick={this.handleSubmit} color="secondary" disabled={this.props.disabledSubmit}>
                        Supprimer
                    </Button>
                    <Button onClick={() => this.props.close()}>
                        Annuler
                    </Button>
                </Box>
            </DialogBox>
        );
    }
}

export default DeleteDialog;

export class DeleteDialogNoPwd extends Component {
    state = { }

    render() {
        return (
            <DialogBox 
                disableBackdropClick
                open={true}
                close={this.props.close}
                title={`Supprimer ${this.props.title}`}
            >
                <Box>
                    <Box p={1}>
                        {this.props.children || this.props.text}
                    </Box>
                    <Alert severity="error">
                        <AlertTitle >Attention</AlertTitle>
                        Cette action sera irréversible
                    </Alert>
                </Box>

                <Box>
                    <Button variant="contained" onClick={this.props.handleSubmit} color="secondary">
                        Supprimer
                    </Button>
                    <Button onClick={() => this.props.close()}>
                        Annuler
                    </Button>
                </Box>
            </DialogBox>
        );
    }
}